import styled from 'styled-components';

export const Container = styled.div`
  h1 {
    text-align: center;
    margin-bottom: 20px;
  }
`;
